import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, Check, Piano, Palette } from "lucide-react";
import { transportObjet } from "../mock/extraData";
import Reveal from "../components/Reveal";

const TransportObjet = () => {
  const navigate = useNavigate();
  useEffect(() => window.scrollTo(0, 0), []);

  const go = (label) => navigate(`/contact?service=${encodeURIComponent(label)}`);

  return (
    <div className="pt-16 sm:pt-20">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={transportObjet.hero.image} alt="Transport d'objet" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#131f38]/95 to-[#1B2A4A]/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-28">
          <div className="max-w-2xl animate-fadeUp">
            <span className="inline-block bg-[#C9A227] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">Transport d'objet</span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">{transportObjet.hero.title}</h1>
            <p className="mt-5 text-lg text-gray-200 max-w-xl">{transportObjet.hero.subtitle}</p>
            <button onClick={() => go("Transport d'objet")} className="mt-8 inline-flex items-center gap-2 bg-[#C9A227] hover:bg-[#b8931f] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors shadow-lg">
              Demander un devis <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {transportObjet.intro.map((p, i) => (
            <p key={i} className="text-gray-600 leading-relaxed mb-4 text-lg">{p}</p>
          ))}
        </div>
      </section>

      {/* TWO SPECIALTIES */}
      <section className="pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Objets lourds */}
          <Reveal className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden hover:shadow-xl transition-shadow">
            <div className="h-52 overflow-hidden">
              <img src={transportObjet.lourds.image} alt="Objets lourds" className="w-full h-full object-cover" />
            </div>
            <div className="p-7">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-[#1B2A4A]/5 flex items-center justify-center">
                  <Piano size={24} className="text-[#1B2A4A]" />
                </div>
                <h2 className="text-2xl font-bold text-[#1B2A4A]">Objets lourds</h2>
              </div>
              <p className="mt-4 text-gray-600 text-sm leading-relaxed">{transportObjet.lourds.desc}</p>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {transportObjet.lourds.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <Check size={16} className="text-[#C9A227] mt-0.5 shrink-0" /> {it}
                  </li>
                ))}
              </ul>
              <button onClick={() => go("Transport objets lourds")} className="mt-6 w-full border-2 border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A] hover:text-white font-semibold py-2.5 rounded-lg transition-colors">
                Devis objets lourds
              </button>
            </div>
          </Reveal>

          {/* Objets d'art */}
          <Reveal delay={150} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden hover:shadow-xl transition-shadow">
            <div className="h-52 overflow-hidden">
              <img src={transportObjet.art.image} alt="Objets d'art" className="w-full h-full object-cover" />
            </div>
            <div className="p-7">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-[#1B2A4A]/5 flex items-center justify-center">
                  <Palette size={24} className="text-[#1B2A4A]" />
                </div>
                <h2 className="text-2xl font-bold text-[#1B2A4A]">Objets d'art</h2>
              </div>
              <p className="mt-4 text-gray-600 text-sm leading-relaxed">{transportObjet.art.desc}</p>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {transportObjet.art.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <Check size={16} className="text-[#C9A227] mt-0.5 shrink-0" /> {it}
                  </li>
                ))}
              </ul>
              <button onClick={() => go("Transport objets d'art")} className="mt-6 w-full border-2 border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A] hover:text-white font-semibold py-2.5 rounded-lg transition-colors">
                Devis objets d'art
              </button>
            </div>
          </Reveal>
        </div>
      </section>

      {/* GUARANTEES */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <span className="text-[#C9A227] font-semibold text-sm uppercase tracking-wider">Nos garanties</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mt-2">Un savoir-faire d'exception</h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {transportObjet.guarantees.map((g, i) => {
              const Icon = Icons[g.icon] || Icons.ShieldCheck;
              return (
                <Reveal key={i} delay={(i % 4) * 100} className="text-center bg-white rounded-2xl p-7 border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                  <div className="mx-auto w-14 h-14 rounded-xl bg-[#1B2A4A]/5 flex items-center justify-center">
                    <Icon size={26} className="text-[#C9A227]" />
                  </div>
                  <h3 className="mt-4 font-bold text-[#1B2A4A]">{g.title}</h3>
                  <p className="mt-2 text-gray-600 text-sm">{g.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1B2A4A]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Un objet précieux à transporter ?</h2>
          <p className="text-gray-300 mb-8">Confiez-nous vos biens les plus lourds ou les plus précieux. Devis gratuit et sur mesure.</p>
          <button onClick={() => go("Transport d'objet")} className="inline-flex items-center gap-2 bg-[#C9A227] hover:bg-[#b8931f] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors shadow-lg">
            Demander un devis <ArrowRight size={18} />
          </button>
        </div>
      </section>
    </div>
  );
};

export default TransportObjet;
